import React from 'react';
import './UndoToast.css';
import UndoIcon from '../Assests/reload.svg';
import PropTypes from 'prop-types';

const UndoToast = ({ message, onUndo, visible, showUndo = false }) => {
    if (!visible) return null;

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    zIndex: 1300,
                    background: 'rgba(0,0,0,0.5)',
                    pointerEvents: 'none',
                }}
            />
            <div className="undo-toast-container">
                <div className="undo-toast-message">{message}</div>
                {showUndo && (
                    <button className="undo-toast-button" onClick={onUndo}>
                        Undo <img src={UndoIcon} alt="Undo" className="undo-toast-icon" />
                    </button>
                )}
            </div>
        </>
    );
};

UndoToast.propTypes = {
    message: PropTypes.string.isRequired,
    onUndo: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    showUndo: PropTypes.bool,
};

export default UndoToast; 